/**
 * Re-exports query-string v8 parse/stringify for CJS/Webpack/Babel consumers.
 * The package exposes only a default namespace export; named imports from 'query-string'
 * break under our interop (runtime: parse is not a function). Import from here instead.
 */
import queryString from 'query-string';

const { parse, stringify } = queryString;

export { parse, stringify };
